var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export default (function (id, password) { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation updatePasswordMutation($input: UpdatePasswordInput!) {\n      updatePassword(input: $input) {\n        ok\n      }\n    }\n  "], ["\n    mutation updatePasswordMutation($input: UpdatePasswordInput!) {\n      updatePassword(input: $input) {\n        ok\n      }\n    }\n  "]))),
    variables: { input: { id: id, password: password } },
}); });
var templateObject_1;
